import { graphql } from '@/gql';

export const contactFieldsFragment = graphql(/* GraphQL */ `
  fragment ContactFields on ContactEntity {
    phone
    email
    instagramProfile
    telegramProfile
    whatsappProfile
    youtubeProfile
    vkProfile
    odnoklassnikiProfile
    personalSite
  }
`);

export const socialFieldsFragment = graphql(/* GraphQL */ `
  fragment SocialFields on ContactEntity {
    instagramProfile
    telegramProfile
    whatsappProfile
    youtubeProfile
    vkProfile
    odnoklassnikiProfile
    personalSite
  }
`);
